// @ts-nocheck
import loadProduct from "@insite/client-framework/Store/Data/Products/Handlers/LoadProduct";
import { useDispatch } from "react-redux";

export default () => {
    const dispatch = useDispatch();
    return (id: string) => dispatch(loadProduct({ id }));
};
